import axios, { AxiosResponse } from 'axios';
import { reportErrorSentry } from 'src/bff';
import { modelCar } from 'src/types';
import { getDataUrl } from '../get-data-url';

export const getVehiculosModelo = async (): Promise<modelCar[]> => {
  try {
    const dataUrl = getDataUrl();
    const response: AxiosResponse = await axios.get(`${dataUrl}/getVehiculosModelos`);
    return response.data.vehiculos;
  } catch (error) {
    reportErrorSentry(error);
    return null;
  }
};
